import { getUnavailableChoices } from './getUnavailableChoices';

export const getUnavailableChoiceIds = (
  choiceSets: ChoiceSet[],
  state: EntireFrontendState,
): Set<string> => {
  const unavailable = getUnavailableChoices(
    choiceSets.flatMap(cs => cs.choices),
    state,
  );
  return new Set(Object.keys(unavailable).filter(id => unavailable[id]));
};
